var Backbone = require('backbone'),
    BasePage = require('./basePg.js'),
    fvChannel = require('glRadio').channel('FV');


module.exports = BasePage.extend({

    typeIdentifier: 'THUMB',

    SPIN_JS_OPTS: { length: 4, radius: 4, width: 2 },

    nonRenderableOrigDimensions: BasePage.prototype.STANDARD_PG_DIMS,


    _getSetWidth: function() {

       return fvChannel.request('cssConstants').THUMB_WIDTH;

    },

    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {

        var originalDimensions;

        if (!isRenderable) {

            originalDimensions = this.nonRenderableOrigDimensions;

        } else if (attrs.originalImageProperties) {

            originalDimensions = {
                w: attrs.originalImageProperties.width,
                h: attrs.originalImageProperties.height
            };

        } else {

            originalDimensions = this.unknownOrigDimsDimensions;
        }

        return Math.round( this._getSetWidth() * ( originalDimensions.h / originalDimensions.w  ) );

    }

    
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/thumbnail.js
 ** module id = 400
 ** module chunks = 0
 **/